window.clientTz = moment.tz.guess();
import pluralize from 'pluralize'
import moment from 'moment-timezone'


export default {

    methods: {

        trialEndDateFromNow(format = 'MMM D, YYYY') {
            return this.$moment().add(config.trialDays, 'days').format(format)
        },

        diffForHumans(date) {
            return moment.utc(date).tz(clientTz).fromNow()
        },

        redirectTo(url, type) {
            if (type == '_blank') {
                window.open(url, type);
                return;
            }
            window.location.href = url;
        },

        refreshPage() {
            location.reload();
        },

        strLimit(value, length = 100) {
            return _.truncate(value, {
                length: length
            })
        },

        strtolower(value) {
            return value.toLowerCase()
        },

        slugify(value) {
            return slugify(value.toLowerCase())
        },

        pluralize(string, count, prefix = false) {
            return pluralize(string, count, prefix)
        },

        repeatString(string, count) {
            if (count == null) return ''
            return string.repeat(count)
        },

        getFileSize(file) {
            if (window.ActiveXObject) {
                var fso = new ActiveXObject("Scripting.FileSystemObject");
                var filepath = file.value;
                var thefile = fso.getFile(filepath);
                return thefile.size / 1000000;
            }
            return file.size / 1000000;
        },

        url(path = '') {
            return config.url + path
        }
    },

    computed: {

        screenInfo() {
            let width = viewport().width;
            return {
                sm: width > 576,
                md: width > 768,
                lg: width > 992,
                xl: width > 1200,
                xxl: width > 1300
            }
        },


        isMobile() {
            if (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0)) {
                return true;
            }
            return false;
        },

        trialDays() {
            return config.trialDays;
        },

        authUser() {
            return config.user
        },

        isAuth(){
            return config.user !== null
        },

        membershipInformation(){
            return config.membership
        }
    }
}
